// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_52-0";
export var eligibilityCardNotEligible = "_52-1";